import { Table, TableCell } from '@repo/ui';
import { ReactNode } from 'react';

export const ResultTableRow = ({ label, value, emphasize = false }: { label: string; value?: ReactNode; emphasize?: boolean }) => {
  if (!value) return null;

  return (
    <Table
      headerCell={<TableCell variant={'header'}>{label}</TableCell>}
      contentCell={<TableCell className={'flex-1 text-right'}>{emphasize ? <span className={'font-bold'}>{value}</span> : value}</TableCell>}
    />
  );
};
